export default __webpack_public_path__ + "media/images/trf-route-default-hero-5431ff8e370ea10cc5336f4086701fc0.jpg";